import Spacer from '@/common/components/spacer';
import CarImagePlaceholder from '@/icons/car-image-placeholder';

interface MissingImagePlaceholderProps {
  shouldOmitText?: boolean;
}

export default function MissingImagePlaceholder({
  shouldOmitText = false,
}: MissingImagePlaceholderProps) {
  return (
    <div className="flex h-full w-full items-center justify-center rounded-md border-2 border-dashed border-border bg-flexcar-neutral90">
      <CarImagePlaceholder />
      {!shouldOmitText && (
        <>
          <Spacer variant="width8" />
          <p className="body h-auto max-w-full">Photo coming soon</p>
        </>
      )}
    </div>
  );
}
